export default __webpack_public_path__ + "static/media/coluna-sistema.97973dcb.jpg";